<!--
 * @author: JJ
 * @since: 2024-09-29
 * home.vue
-->
<template>
	<div class="container">
		<Header :userInfo="userInfo" />
		<header-search></header-search>
		<mainTab :nindex="0" :color="'#fff'" :phone="iconphone" />
		<div class="bgbe">
			<div class="flex flex-start w1440">
				<div class="left_recomd">
					<div class="top_nav flex-box">
						<img src="../../assets/static/icon/jj_icon_cate.png" alt="" />
						<div>产品分类</div>
					</div>
					<template v-for="(item, index) in categoryList" :key="index">
						<template v-if="index < 5">
							<div class="left_item">
								<router-link
									:to="'/FindProduct?first_category_id=' + item.id + '&first_category_index=' + index"
									class="flex-box cursor">
									<img :src="item.icon_text" class="ico27" alt="" />
									<div class="flex-grow-1 fs16 col27 pl8">{{ item.name }}</div>
									<img src="../../assets/static/icon/jj_icon_arrow.png" class="ico10" alt="" />
								</router-link>
								<div class="mt15 cola4 m-ellipsis fs14 pr40" v-if="item?.children.length > 0">
									<span v-for="(items, indexs) in item.children" :key="indexs">{{ items.name
										}}/</span>
								</div>
								<ul class="pop flex-box flex-wrap" v-if="item?.children.length > 0">
									<template v-for="(items, indexs) in item.children" :key="indexs">
										<li>
											<router-link
												:to="{ path: '/FindProduct', query: { first_category_id: item.id, first_category_index: index, category_id: items.id, category_index: indexs } }">{{
													items.name }}</router-link>
										</li>
									</template>
								</ul>
							</div>
						</template>
					</template>
				</div>
				<div class="flex-grow-1 plr10 pb10">
					<div class="home_swiper">
						<swiper :pagination="{ clickable: true }"
							:autoplay="{ delay: 3000, disableOnInteraction: false }" @swiper="onSwiper"
							@slideChange="onSlideChange" class="home_swiper" :observer="true" :observeParents="true"
							:modules="modules" loop ref="swiper">
							<swiper-slide class="swiper_item" v-for="(item, index) in banner" :key="index">
								<a class="top_banner cu flex flex-center flex-col" @click="jump(item.url)"
									:style="{ backgroundImage: `url(${item.image_text})` }"></a>
							</swiper-slide>
						</swiper>
						<img src="../../assets/static/icon/jj_icon_swiper_left.png" class="swiper_arrow_left cursor"
							@click="prev" alt="" />
						<img src="../../assets/static/icon/jj_icon_swiper_right.png" class="swiper_arrow_right cursor"
							@click="next" alt="" />
					</div>
					<div class="ad_box flex-box">
						<img :src="item.image_text" @click="jump(item.url)" v-for="(item, index) in advertise"
							:key="index" class="ad_img cursor" alt="" />
					</div>
				</div>
				<div class="right_profile">
					<div class="before"></div>
					<div class="mlra">
						<upLoad @upSuc="uploadAavtar">
							<div class="user_header_box">
								<img :src="userInfo?.avatar || avatar" alt="" />
							</div>
						</upLoad>
					</div>
					<template v-if="!isLogin">
						<div class="tc mt10 col5d fs16 fwb lh30">欢迎使用小狮优选平台</div>
						<div class="flex-box flex-center mt20">
							<router-link to="/Login" class="btn_login">登 录</router-link>
							<router-link to="/NewInstitutions" class="btn_register">注 册</router-link>
						</div>
					</template>
					<template v-else>
						<div class="info">
							<div class="flex flex-center">
								<div class="tc mt10 fs14">
									<div class="col65 fwb">{{ userInfo?.company_name }}</div>
									<div class="mt5 col90">手机号：{{ userInfo?.mobile }}</div>
								</div>
								<div class="vip flex-box ml5" v-if="userInfo?.vip">
									<img :src="userInfo?.vip?.image_text" class="vip_ico" alt="" />
									<div class="pl2">{{ userInfo?.vip?.name }}</div>
								</div>
							</div>
							<div class="flex-box mt10 plr30">
								<div class="flex-grow-1 tc cursor" @click="onScoreLog">
									<div class="col3d fs18 fwb">{{ userInfo?.score }}</div>
									<div class="col27 fs14">积分</div>
								</div>
								<div class="flex-grow-1 tc cursor" @click="onInstitution"
									v-if="userInfo && userInfo.institution_type == 1">
									<div class="col3d fs18 fwb">
										{{ userInfo.institution_sun_count || 0 }}
										<span class="fw400 col3d">家</span>
									</div>
									<div class="col27 fs14">子机构</div>
								</div>
							</div>
						</div>
					</template>
					<div>
						<div class="right_profile_item cursor" @click="toPage('/Collection')">
							<img src="../../assets/static/icon/jj_profile_icon1.png" alt="" />
							<div>我的收藏</div>
						</div>
						<div class="right_profile_item cursor" @click="toPage('/Invoice')">
							<img src="../../assets/static/icon/jj_profile_icon2.png" alt="" />
							<div>发票管理</div>
						</div>
						<div class="right_profile_item cursor" @click="toPage('/HelpCenter')">
							<img src="../../assets/static/icon/jj_profile_icon3.png" alt="" />
							<div>帮助中心</div>
						</div>
						<div class="right_profile_item cursor" @click="toPage('/IncomeDetail')">
							<img src="../../assets/static/icon/jj_profile_icon4.png" alt="" />
							<div>积分收益</div>
						</div>
						<div class="right_profile_item cursor" @click="toPage('/ServiceTerm')">
							<img src="../../assets/static/icon/jj_profile_icon5.png" alt="" />
							<div>服务条款</div>
						</div>
						<div class="right_profile_item cursor" @click="toPage('/AboutUs')">
							<img src="../../assets/static/icon/jj_profile_icon6.png" alt="" />
							<div>关于我们</div>
						</div>
					</div>
					<div class="notice_box flex-box" v-if="showmess">
						<img src="../../assets/static/icon/jj_icon_notice.png" class="ico51" alt="" />
						<div class="flex-grow-1 pl8">
							<swiper direction="vertical" :slides-per-view="isbigpc ? 3 : 2" :space-between="5"
								class="notice_swiper" :observer="true" :observeParents="true" :modules="modules" loop
								:autoplay="showmess ? auto : false" :slidesPerview="6" @swiper="swiperOptionMid">
								<swiper-slide class="cursor" v-for="(item, index) in messageList" :key="index">
									<router-link :to="'/Message?type='+(item.message_group||'')" class="m-ellipsis con1">{{ item.title
										}}</router-link>
								</swiper-slide>
							</swiper>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt15 w1440">
			<!-- 万件拼团 -->
			<div class="new_goods_nav">
				<div class="goods_pay">
					<div class="flex-box">
						<img src="../../assets/static/icon/jj_new_icon1.png" class="ico24" alt="" />
						<div class="flex-grow-1 fwb fs20 col27 pl10">万件拼团</div>
						<router-link class="more" :to="'/Activities?type=' + activityList0?.type">更多</router-link>
					</div>
					<ul class="million_pay_ul">
						<template v-if="activityList0?.activityGoods?.length > 0">
							<template v-for="(item, index) in activityList0?.activityGoods" :key="index">
								<li class="million_pay_link cursor" v-if="index < 3">
									<router-link
										:to="'/FindProductDetail?id=' + item.id + '&activity_id=' + item.activity.id + '&activity_type=' + activityList0.type">
										<img :src="item.image_text" class="cover" alt="" />
										<div class="m-ellipsis fs16 mt10 fwb col4c lh22">{{ item.title }}</div>
										<div class="coleb fs16 fwb mb5" v-if="!isLogin">价格登录可见</div>
										<div class="coleb fwb mb5" v-else>
											<span class="fs14">¥</span>
											<span class="fs16" v-if="item.new_sku_prices[0].prices.length > 0">{{
												item.new_sku_prices[0].prices.length > 1 ?
													item.new_sku_prices[0].prices[0] + "~" +
													item.new_sku_prices[0].prices[1] : item.new_sku_prices[0].prices[0]
												}}</span>
											<span class="fs16" v-else>暂无价格</span>
											<span class="fs12">元/{{ item.unit }}</span>
										</div>
										<div class="h28">
											<template v-for="(params, indexs) in item.params_text" :key="indexs">
												<div class="col96 fs12 lh16 mb5 m-ellipsis" v-if="indexs < 2">{{
													params.title }}：{{ params.content }}</div>
											</template>
										</div>
										<div class="flex-box mt5 h18">
											<div class="fs12 col96">拼团进度</div>
											<div class="progree_nav">
												<div class="progree_nav_box">
													<div class="progree_nav_box_active"
														:style="{ width: `${item.rate}%` }"></div>
												</div>
											</div>
											<div class="col3d fs12 fwb pl12">{{ item.rate }}%</div>
										</div>
									</router-link>
								</li>
							</template>
						</template>
						<template v-else>
							<div class="nodata fs16 tc">
								<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
								<div>暂无相关数据</div>
							</div>
						</template>
					</ul>
				</div>
			</div>
			<!-- 限时购 -->
			<div class="time_pay_nav">
				<div class="time_pay">
					<div class="flex-box">
						<img src="../../assets/static/icon/jj_new_icon2.png" class="ico24" alt="" />
						<div class="fwb fs20 col27 pl10">限时购</div>
						<div class="flex-center flex-box flex-grow-1 fwb fs16 cole6">
							<span v-if="todayList">距离秒杀结束还剩：</span>
							<template v-if="todayList?.seconds">
								<countDown :totalTime="todayList.seconds" :color="'#EB3F25'"></countDown>
							</template>
						</div>
						<router-link class="more" :to="'/Activities?type=' + activityList2?.type">更多</router-link>
					</div>
					<ul class="countdown_ul" v-if="todayList">
						<template v-for="(item, index) in spikesListToday" :key="index">
							<li class="countdown_goods cursor" v-if="index < 3">
								<router-link
									:to="'/FindProductDetail?id=' + item.id + '&activity_id=' + item.activity.id + '&activity_type=' + activityList2?.type">
									<img :src="item.image_text" class="cover" alt="" />
									<div class="m-ellipsis fs16 fwb col4c mt10 lh22">{{ item.title }}</div>
									<div class="coleb fs16 fwb mb5" v-if="!isLogin">价格登录可见</div>
									<div class="coleb mb5" v-else>
										<span class="fs14">¥</span>
										<span class="fs16">{{ item.new_sku_prices[0].price }}</span>
										<span class="fs12">元/{{ item.unit }}</span>
									</div>
									<div class="h28">
										<template v-for="(params, indexs) in item.params_text" :key="indexs">
											<div class="col96 mb5 fs12 lh16 m-ellipsis" v-if="indexs < 2">{{
												params.title }}：{{ params.content }}</div>
										</template>
									</div>
									<div class="number_span m-ellipsis fs12">
										剩余库存：
										<span>{{ item.new_sku_prices[0].stock }}</span>
									</div>
								</router-link>
							</li>
						</template>
					</ul>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
							<div>暂无相关数据</div>
						</div>
					</template>
				</div>
			</div>
			<!-- 新品体验 -->
			<div class="new_goods_nav new mt10">
				<div class="goods_pay">
					<div class="flex-box">
						<img src="../../assets/static/icon/jj_new_icon3.png" class="ico24" alt="" />
						<div class="fwb flex-grow-1 fs20 col27 pl10">新品体验</div>
						<router-link class="more" :to="'/Activities?type=' + activityList1?.type">更多</router-link>
					</div>
					<ul class="countdown_ul" v-if="activityList1?.activityGoods?.length > 0">
						<template v-for="(item, index) in activityList1?.activityGoods" :key="index">
							<li class="countdown_goods cursor" v-if="index < 3">
								<router-link :target="isLogin ? blank : ''"
									:to="'/FindProductDetail?id=' + item.id + '&activity_id=' + item.activity.id + '&activity_type=' + activityList1.type">
									<img :src="item.image_text" class="cover" alt="" />
									<div class="m-ellipsis fs16 fwb col4c lh22 mt10">{{ item.title }}</div>
									<div class="coleb fs16 fwb mb5" v-if="!isLogin">价格登录可见</div>
									<div class="coleb fwb mb5" v-else>
										<span class="fs14">¥</span>
										<span class="fs16">{{ item.new_sku_prices[0].price }}</span>
										<span class="fs12">元/{{ item.unit }}</span>
									</div>
									<div class="h28">
										<template v-for="(params, indexs) in item.params_text" :key="indexs">
											<div class="col96 mb5 fs12 lh16 m-ellipsis" v-if="indexs < 2">{{
												params.title }}：{{ params.content }}</div>
										</template>
									</div>

									<div class="number_span fs12 m-ellipsis">截止时间：{{
										item.activity.end_time_text }}
									</div>
								</router-link>
							</li>
						</template>
					</ul>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
							<div>暂无相关数据</div>
						</div>
					</template>
				</div>
			</div>
			<!-- 临期产品 -->
			<div class="new_goods_nav endtime mt10">
				<div class="goods_pay">
					<div class="flex-box">
						<img src="../../assets/static/icon/jj_new_icon4.png" class="ico24" alt="" />
						<div class="fwb flex-grow-1 fs20 col27 pl10">临期产品</div>
						<router-link class="more" :to="'/Activities?type=' + activityList3?.type">更多</router-link>
					</div>
					<ul class="countdown_ul" v-if="activityList3?.activityGoods?.length > 0">
						<template v-for="(item, index) in activityList3?.activityGoods" :key="index">
							<li class="countdown_goods cursor" v-if="index < 3">
								<router-link :target="isLogin ? blank : ''"
									:to="'/FindProductDetail?id=' + item.id + '&activity_id=' + item.activity.id + '&activity_type=' + activityList3.type">
									<img :src="item.image_text" class="cover" alt="" />
									<div class="m-ellipsis fs16 fwb col4c lh22 mt10">{{ item.title }}</div>
									<div class="coleb fs16 fwb mb5" v-if="!isLogin">价格登录可见</div>
									<div class="coleb fwb mb5" v-else>
										<span class="fs14">¥</span>
										<span class="fs16">{{ item.new_sku_prices[0].price }}</span>
										<span class="fs12">元/{{ item.unit }}</span>
									</div>
									<div class="h28">
										<template v-for="(params, indexs) in item.params_text" :key="indexs">
											<div class="col96 mb5 fs12 lh16 m-ellipsis" v-if="indexs < 2">{{
												params.title }}：{{ params.content }}</div>
										</template>
									</div>

									<div class="number_span fs12 m-ellipsis">有效期：{{ item.new_sku_prices[0].expiretime }}
									</div>
								</router-link>
							</li>
						</template>
					</ul>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
							<div>暂无相关数据</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<!-- 万件拼团 -->
		<!-- <div class="mt40 million_pay_box">
			<img src="../../assets/static/images/jj_title0.png" class="jj_title0" alt="">
			<img src="../../assets/static/icon/jj_icon_more.png" class="more cursor" alt=""
				@click="toPagePrarm('/Activities', { 'type': activityList0?.type })" />
			<div class="million_pay_ulb">
				<ul class="million_pay_ul">
					<template v-if="activityList0?.activityGoods?.length > 0">
						<template v-for="(item, index) in activityList0?.activityGoods" :key="index">
							<li @click="toPagePrarmTag('/FindProductDetail', { 'id': item.id, 'activity_id': item.activity.id, 'activity_type': activityList0.type })"
								class="million_pay_link cursor flex-box" v-if="index < 6">
								<img :src="item.image_text" class="cover" alt="" />
								<div class="flex-grow-1 pl24">
									<div class="m-ellipsis fs16 fwb col4c lh22">{{ item.title }}</div>
									<div class="coleb mt5 fs15 fwb lh21 mb10" v-if="!isLogin">价格登录可见</div>
									<div class="coleb mt5 fwb lh21" v-else>
										<span class="coleb fs14 fwb">¥</span><span class="coleb fwb fs16"
											v-if="item.new_sku_prices[0].prices.length > 0">{{
												item.new_sku_prices[0].prices.length > 1 ? item.new_sku_prices[0].prices[0]
													+
													'~' +
													item.new_sku_prices[0].prices[1] : item.new_sku_prices[0].prices[0]
											}}</span>
										<span class="coleb fwb fs16" v-else>暂无价格</span>
										<span class="coleb fs12 coleb fwb">元/{{ item.unit }}</span>
									</div>
									<template v-for="(params, indexs) in item.params_text" :key="indexs">
										<div class=" col96 fs13 lh16 mb5 m-ellipsis" v-if="indexs < 2">{{ params.title
											}}：{{
												params.content
											}}
										</div>
									</template>
									<div class="fs10 col96 lh12">拼团进度</div>
									<div class="flex-box mt5">
										<div class="progree_nav">
											<div class="progree_nav_box">
												<div class="progree_nav_box_active" :style="{ width: `${item.rate}%` }">
												</div>
											</div>
										</div>
										<div class="col3d fs10 fwb pl5">{{ item.rate }}%</div>
									</div>
									<div class="btn_million_pay cursor">立即拼团</div>
								</div>
							</li>
						</template>
					</template>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
							<div>暂无相关数据</div>
						</div>
					</template>
				</ul>
			</div>
		</div> -->
		<!-- 今日秒杀 -->
		<!-- <div class="today_pay_box mt20" v-if="activityList2">
			<img src="../../assets/static/images/jj_title1.png" class="jj_title1" alt="">
			<div class="today_pay_ulb">
				<div class="today_pay_ul">
					<div class="tr fs18 fwb colfe cursor"><span class="tr"
							@click="toPagePrarm('/Activities', { 'type': activityList2?.type })">更多>></span>
					</div>
					<template v-if="todayList || tomorrowList">
						<div class="countdown_box" v-if="todayList">
							<div class="flex-box">
								<div class="btn_count"><span>今日秒杀</span></div>
								<div class="flex-grow-1 flex-box flex-center">
									<div class="count_item" :style="{ backgroundImage: `url(${coutimg})` }">{{ todaysh
										}}
									</div>
									<div class="count_span"></div>
									<div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg})` }">{{
										todaysm
									}}</div>
									<div class="count_span_split"></div>
									<div class="count_item" :style="{ backgroundImage: `url(${coutimg})` }">{{ todayeh
										}}
									</div>
									<div class="count_span"></div>
									<div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg})` }">{{
										todayem
									}}</div>
								</div>
								<div class="btn_count"><span>限时秒杀时间</span></div>
							</div>
							<div class="tc">
								<span class="col49 fs20">距离秒杀结束还剩：</span>
								<countDown :totalTime="todayList.seconds" :color="'#EB3F25'"></countDown>
							</div>
						</div>
						<ul class="countdown_ul" v-if="todayList">
							<li @click="toPagePrarmTag('/FindProductDetail', { 'id': item.id, 'activity_id': item.activity.id, 'activity_type': activityList2?.type })"
								class="countdown_goods cursor" v-for="(item, index) in spikesListToday" :key="index">
								<img :src="item.image_text" class="cover" alt="" />
								<div class="number_span fs14">剩余库存：<span class="fwb">{{ item.new_sku_prices[0].stock
										}}</span>
								</div>
								<div class="sq"></div>
								<div class="plr16">
									<div class="m-ellipsis-l2 goods_title fs16">{{ item.title }}</div>
									<div class="coleb mt5 fs15 fwb lh21 mb10" v-if="!isLogin">价格登录可见</div>
									<div class="coleb mt5 fwb lh21" v-else><span class="coleb fs14 fwb">¥</span><span
											class="coleb fwb fs16">{{
												item.new_sku_prices[0].price }}</span><span
											class="coleb fs12 coleb fwb">元/{{
												item.unit }}</span></div>
									<template v-for="(params, indexs) in item.params_text" :key="indexs">
										<div class=" col96 mb5 fs13 lh16 m-ellipsis" v-if="indexs < 2">{{ params.title
											}}：{{
												params.content }}</div>
									</template>
									<div class="btn_sure cursor">立即秒杀</div>
								</div>
							</li>
						</ul>
					
						<div class="countdown_box c1" v-if="tomorrowList">
							<div class="flex-box">
								<div class="btn_count"><span>明日预告</span></div>
								<div class="flex-grow-1 flex-box flex-center">
									<div class="count_item" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{
										tomorrowsh }}
									</div>
									<div class="count_span gray"></div>
									<div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{
										tomorrowsm
									}}
									</div>
									<div class="count_span_split gray"></div>
									<div class="count_item" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{
										tomorroweh }}
									</div>
									<div class="count_span gray"></div>
									<div class="count_item ml8" :style="{ backgroundImage: `url(${coutimg_gray})` }">{{
										tomorrowem
									}}
									</div>
								</div>
								<div class="btn_count_uc"><span>限时秒杀时间</span></div>
							</div>
							<div class="tc">
								<span class="col49 fs20">距离秒杀开始还剩：</span>
								<countDown :totalTime="tomorrowList?.seconds" :color="'#EB3F25'"></countDown>
							</div>
						</div>
						<ul class="countdown_ul" v-if="tomorrowList">
							<li @click="toPagePrarmTag('/FindProductDetail', { 'id': item.id, 'activity_id': item.activity.id, 'activity_type': activityList2?.type })"
								class="countdown_goods cursor" v-for="(item, index) in spikesListTomorrow" :key="index">
								<img :src="item.image_text" class="cover" alt="" />
								<div class="number_span fs14">剩余库存：<span class="fwb">{{ item.new_sku_prices[0].stock
										}}</span></div>
								<div class="sq"></div>
								<div class="plr16">
									<div class="m-ellipsis-l2 goods_title fs16">{{ item.title }}</div>
									<div class="coleb mt5 fs15 fwb lh21 mb10" v-if="!isLogin">价格登录可见</div>
									<div class="coleb mt5 fwb lh21" v-else><span class="coleb fs14 fwb">¥</span><span
											class="coleb fwb fs16">{{
												item.new_sku_prices[0].price }}</span><span
											class="coleb fs12 coleb fwb">元/{{
												item.unit
											}}</span>
									</div>
									<template v-for="(params, indexs) in item.params_text" :key="indexs">
										<div class=" col96 mb5 fs13 lh16 m-ellipsis" v-if="indexs < 2">{{ params.title
											}}：{{
												params.content }}</div>
									</template>
									<div class="btn_sure cursor">立即预约</div>
								</div>
							</li>
						</ul>
					</template>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
							<div>暂无相关数据</div>
						</div>
					</template>
				</div>
			</div>
		</div> -->
		<!-- 临期产品 -->
		<!-- <div class="endtime_pay_box mt20">
			<img src="../../assets/static/images/jj_title2.png" class="jj_title2" alt="">
			<img src="../../assets/static/images/jj_title3.png" class="jj_title3" alt="">
			<div class="endtime_pay_ulb">
				<div class="tr fs18 fwb col9d cursor pr40">
					<span @click="toPagePrarm('/Activities', { 'type': activityList3?.type })">更多>></span>
				</div>
				<div class="endtime_pay_ul">
					<ul class="countdown_ul">
						<template v-if="activityList3?.activityGoods?.length > 0">
							<template v-for="(item, index) in activityList3?.activityGoods" :key="index">
								<li @click="toPagePrarmTag('/FindProductDetail', { 'id': item.id, 'activity_id': item.activity.id, 'activity_type': activityList3.type })"
									class="countdown_goods cursor big">
									<img :src="item.image_text" class="cover" alt="" />
									<div class="number_span fs14" v-if="item.new_sku_prices.length > 0">有效期：<span
											class="fwb">{{
												item.new_sku_prices[0].expiretime }}</span></div>
									<div class="sq"></div>
									<div class="plr16">
										<div class="m-ellipsis-l2 goods_title fs16">{{ item.title }}</div>
										<div class="coleb mt5 fs15 fwb lh21 mb10" v-if="!isLogin">价格登录可见</div>
										<div class="coleb mt5 fwb lh21" v-else><span
												class="coleb fs14 fwb">¥</span><span class="coleb fwb fs16">{{
													item.new_sku_prices[0].price }}</span><span
												class="coleb fs12 coleb fwb">元/{{ item.unit }}</span></div>
										<template v-for="(params, indexs) in item.params_text" :key="indexs">
											<div class=" col96 fs13 lh16 mb5 m-ellipsis" v-if="indexs < 1">{{
												params.title }}：{{
													params.content
												}}
											</div>
										</template>
										<div class=" col96 fs13 lh16">剩余库存：{{ item.new_sku_prices[0].stock }}</div>
										<div class="btn_sure cursor">立即购买</div>
									</div>
								</li>
							</template>
						</template>
						<template v-else>
							<div class="nodata fs16 tc">
								<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
								<div>暂无相关数据</div>
							</div>
						</template>
					</ul>
				</div>
			</div>
		</div> -->
		<!-- 新品体验 -->
		<!-- <div class="new_pay_box mt20">
			<div class="flex flex-start">
				<img src="../../assets/static/images/jj_new_poster.png"
					@click="toPagePrarm('/Activities', { 'type': activityList1?.type })" class="new_pay_poster cursor"
					alt="" />
				<div class="countdown_ul flex-grow-1 pl16">
					<template v-if="activityList1?.activityGoods?.length > 0">
						<template v-for="(item, index) in activityList1?.activityGoods" :key="index">
							<router-link :target="isLogin ? blank : ''"
								:to="'/FindProductDetail?id=' + item.id + '&activity_id=' + item.activity.id + '&activity_type=' + activityList1.type"
								class="countdown_goods big" v-if="index < 4">
								<img :src="item.image_text" class="cover" alt="" />
								<div class="sq big"></div>
								<div class="plr16">
									<div class="m-ellipsis-l2 goods_title fs16 lh24">{{ item.title }}</div>
									<div class="coleb mt5 fs15 fwb lh21 mb10" v-if="!isLogin">价格登录可见</div>
									<div class="coleb mt5 fwb lh21" v-else><span class="coleb fs14 fwb">¥</span><span
											class="coleb fwb fs16">{{
												item.new_sku_prices[0].price }}</span><span
											class="coleb fs12 coleb fwb">元/{{
												item.unit }}</span>
									</div>
									<div class=" col96 fs12 lh16 mb5 m-ellipsis">
										活动时间：{{ item.activity.start_time_text }}—{{ item.activity.end_time_text }}</div>
									<template v-for="(params, indexs) in item.params_text" :key="indexs">
										<div class="mt5 col96 fs13 m-ellipsis" v-if="indexs < 1">{{ params.title }}：{{
											params.content
										}}
										</div>
									</template>
									<div class="mt5 col96 fs13">剩余名额：{{ item.new_sku_prices[0].stock -
										item.new_sku_prices[0].sales }}个</div>
									<div class="btn_sure cursor">立即报名</div>
								</div>
							</router-link>
						</template>
					</template>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
							<div>暂无相关数据</div>
						</div>
					</template>
				</div>
			</div>
		</div> -->
		<!-- 热门/耗材 -->
		<div class="w1440" v-if="hotCategoryList?.length > 0">
			<img src="../../assets/static/icon/jj_recomd.png" class="recomd_title mt30" alt="" />
			<div class="hot_pay_box mt30">
				<div class="flex-box pb10 pr z2" v-if="hotindex == 0">
					<img :src="hotCategoryList[0].icon_text" class="ico28" alt="" />
					<div class="fs20 col27 flex-grow-1 ml10 cursor">
						<span class="fwb" @click="chooseHot(0)">{{ hotCategoryList[0].name }}</span>
						/
						<span class="fs18 cursor" @click="chooseHot(1)">{{ hotCategoryList[1].name }}</span>
					</div>
					<router-link class="more"
						to="/FindProduct?first_category_id=0&first_category_index=-1&category_id=0&category_index=0">更多</router-link>
				</div>
				<div class="flex-box pb10 pr z2" v-if="hotindex == 1">
					<img :src="hotCategoryList[1].icon_text" class="ico28" alt="" />
					<div class="fs20 col27 flex-grow-1 ml10 cursor">
						<span class="fwb" @click="chooseHot(1)">{{ hotCategoryList[1].name }}</span>
						/
						<span class="fs18 cursor" @click="chooseHot(0)">{{ hotCategoryList[0].name }}</span>
					</div>
					<router-link class="more"
						to="/FindProduct?first_category_id=0&first_category_index=-1&category_id=0&category_index=0">更多</router-link>
				</div>
				<ul class="hot_goods_ul">
					<template v-if="hotCategoryList[hotindex]?.goods?.length > 0">
						<li @click="toPagePrarmTag('/FindProductDetail', { id: item.id })" class="hot_goods_link cursor"
							v-for="(item, index) in hotCategoryList[hotindex]?.goods" :key="index">
							<img :src="item.image_text" class="cover" alt="" />
							<div class="sq"></div>
							<div class="plr10">
								<div class="title fs16 m-ellipsis-l2">{{ item.title }}</div>
								<div class="coleb mt5 fs16 fwb lh21" v-if="!isLogin">价格登录可见</div>
								<div class="coleb mt5 fwb lh21" v-else>
									<span class="fs14">¥</span>
									<span class="fs16" v-if="item.min_max_price[0].min_price">{{
										item.min_max_price[0].min_price + "~" + item.min_max_price[0].max_price
										}}</span>
									<span class="fs14">元/{{ item.unit }}</span>
								</div>

								<div class="flex-box">
									<div class="flex-grow-1 pr15 h28">
										<template v-for="(params, indexs) in item.params_text" :key="indexs">
											<div class="m-ellipsis col96 fs12" v-if="indexs < 2">{{ params.title }}：{{
												params.content }}</div>
										</template>
									</div>
									<img src="../../assets/static/icon/jj_icon_cart.png" class="ico56 cursor" alt="" />
								</div>
							</div>
						</li>
					</template>
					<template v-else>
						<div class="nodata fs16 tc">
							<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
							<div>暂无相关数据</div>
						</div>
					</template>
				</ul>
				<!-- <div class="flex-box flex-end mt30 pr z2">
					<router-link to="/Activities" class="col6b fs16 fwb cursor">点击查看更多</router-link>
					<img src="../../assets/static/icon/jj_icon_arrow1.png" class="ico10 ml5 cursor" alt="" />
				</div> -->
			</div>
		</div>
		<div class="w1440 flex-box flex-between mt20 mb10 comp_title">
			<div class="col27 fs20 fw600">优选品牌</div>
			<router-link to="/brandshow" class="more">更多</router-link>
		</div>
		<div class="w1440 pbrem2">
			<template v-if="brandList?.length > 0">
				<router-link :to="'/BrandShowDetail?id=' + item.id" class="comp_link cursor"
					v-for="(item, index) in brandList" :key="index">
					<img :src="item.image_text" class="cover" alt="" />
					<div class="bottom fs16 m-ellipsis">{{ item.name }}</div>
				</router-link>
			</template>
			<template v-else>
				<div class="nodata fs16 tc">
					<img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
					<div>暂无相关数据</div>
				</div>
			</template>
		</div>
	</div>
	<!-- 登录弹窗 -->
	<!-- <loginPop :visible="isShowLogin" @close="isShowLogin = false" @loginSuc="loginSuc"></loginPop> -->
</template>
<script>
import { useHead } from "@unhead/vue";
import countDown from "../../components/countDown.vue";
import upLoad from "@/components/Upload.vue";
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "../../../node_modules/swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import { ref, onMounted } from "vue";
import moment from "moment";
export default {
	components: {
		countDown,
		upLoad,
		Swiper,
		SwiperSlide,
	},
	setup() {
		let swi = ref("");
		const onSwiper = (e) => {
			swi.value = e;
		};
		const prev = () => {
			swi.value.slidePrev();
		};
		const next = () => {
			swi.value.slideNext();
		};
		const swiperOptionMid = (e) => { };
		onMounted(() => {
			useHead({
				title: "小狮优选",
				meta: [
					{ name: "description", content: "This is my page description" },
					{ property: "og:title", content: "My Page Title" },
					{ property: "og:description", content: "This is my page description" },
					{ property: "og:url", content: "https://example.com/my-page" },
					{ property: "og:image", content: "https://example.com/my-image.jpg" },
				],
				link: [{ rel: "canonical", href: "https://example.com/my-page" }],
			});
		});
		return {
			onSwiper,
			swiperOptionMid,
			prev,
			next,
			modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode],
		};
	},
	data() {
		return {
			recomd_tips1: "玻尿酸/胶原蛋白/再生类/童颜针/少女针/羟基磷灰石",
			banner: [],
			advertise: [],
			items: [{ name: "您的**机构医药资质即将到期，请尽快更新…" }, { name: "您的**机构医药资质即将到期，请尽快更新…" }, { name: "您的**机构医药资质即将到期，请尽快更新…" }, { name: "您的**机构医药资质即将到期，请尽快更新…" }, { name: "您的**机构医药资质即将到期，请尽快更新…" }, { name: "您的**机构医药资质即将到期，请尽快更新…" }],
			progree: "74",
			endTime: 0,
			endTimetomorrow: 0,
			coutimg: require("../../assets/static/images/jj_countdown_red.png"),
			coutimg_gray: require("../../assets/static/images/jj_countdown_gray.png"),
			userInfo: {
				group_model: {
					avatar: "",
					company_name: "",
					score: 0,
					institution_type: 0,
					message_count: 0,
					message: null,
				},
				order_num: {
					unpaid: 0,
					nosend: 0,
					noget: 0,
					aftersale: 0,
				},
				institution_sun_count: 0,
			},
			categoryList: [],
			isLogin: false,
			avatar: require("../../assets/static/icon/jj_profile_normal.png"),
			showmess: false,
			auto: { delay: 3000, disableOnInteraction: false },
			messageList: [],
			activityList: [],
			activityList0: [],
			activityList1: [],
			activityList2: [],
			activityList3: [],
			activityList4: [],
			hotCategoryList: [],
			hotindex: 0,
			brandList: [],
			todayList: null,
			tomorrowList: null,
			todaysh: "00",
			todaysm: "00",
			todayeh: "00",
			todayem: "00",
			tomorrowsh: "00",
			tomorrowsm: "00",
			tomorroweh: "00",
			tomorrowem: "00",
			spikesListToday: [],
			spikesListTomorrow: [],
			blank: "_blank",
			iconphone: require("../../assets/static/icon/jj_phone_new_white.png"),
			screenWidth: 0,
			isbigpc: true,
			// isShowLogin: false,
		};
	},
	mounted() {
		const that = this;
		that.changeSize();
		window.onresize = () => {
			that.changeSize();
		};
	},
	created() {
		if (this.$cookies.get("token")) {
			this.isLogin = true;
			//this.userInfo = this.$cookies.get('userinfo');
			this.getUserInfo();
			this.getMessageList();
		} else {
			this.isLogin = false;
		}
		this.getBanner();
		this.getCategoryList();
		this.getActivityList();
		this.getActivity()
		this.getHotGoodsList();
		this.getBrandListList();
	},

	methods: {
		changeSize() {
			let that = this;
			that.screenWidth = document.documentElement.clientWidth;
			if (that.screenWidth > 1440) {
				that.isbigpc = true;
			} else {
				that.isbigpc = false;
			}
		},
		// loginSuc() {
		// 	this.isShowLogin = false;
		// 	this.$bus.emit("refreshLogin");
		// 	window.location.reload();
		// },
		chooseHot(i) {
			this.hotindex = i;
		},
		jump(url) {
			if (url) {
				window.open(url, "_blank");
			}

		},
		uploadAavtar(e) {
			this.$api.UserProfile({ avatar: e }).then((ret) => {
				this.userInfo.avatar = e;
				window.location.reload();
			});
		},
		// 获取用户信息
		getUserInfo() {
			let that = this;
			that.$api.GetUserInfo().then((res) => {
				that.userInfo = res.data.institution;
				that.userInfo.institution_sun_count = res.data.institution_sun_count;
				if (res.code == 1) {
					let userinfo = {
						avatar: res.data.group_model.avatar,
						mobile: res.data.group_model.mobile,
						vip: res.data.group_model.vip,
						score: res.data.group_model.score,
						institution_sun_count: res.data.institution_sun_count,
						company_name: res.data.group_model.company_name,
						institution_type: res.data.group_model.institution_type,
					};
					this.$cookies.set("userinfo", userinfo);
					this.$bus.emit("refreshLogin");
				}
			});
		},
		onScoreLog() {
			if (!this.isLogin) {
				this.$router.push("/Login");
				return true;
			}
			this.$router.push({ path: "/IncomeDetail" });
		},
		onInstitution() {
			if (!this.isLogin) {
				this.$router.push("/Login");
				return true;
			}
			this.$router.push({ path: "/SubManage" });
		},
		getActivity() {
			this.$api.GetActivity({ list_rows: 3 }).then((res) => {
				if (res.code == 1) {
					let list = res.data;
					list.map((item) => {
						if (item.type == "seckill") {
							this.activityList2 = item;

							if (this.activityList2.today_activity) {
								this.todayList = this.activityList2.today_activity;
								this.todaysh = moment(this.todayList.start_time * 1000).format("HH");
								this.todaysm = moment(this.todayList.start_time * 1000).format("mm");
								this.todayeh = moment(this.todayList.end_time * 1000).format("HH");
								this.todayem = moment(this.todayList.end_time * 1000).format("mm");
								//let activityId = this.activityList2.activity;
								//activityId = activityId.length ? activityId.join(",") : "0";
								let activityId = this.activityList2.today_activity.id;
								this.checkSpikesToday(activityId);
							}
							// if (this.activityList2.tomorrow_activity) {
							// 	this.tomorrowList = this.activityList2.tomorrow_activity;
							// 	this.tomorrowsh = moment(this.todayList.start_time * 1000).format("HH");
							// 	this.tomorrowsm = moment(this.todayList.start_time * 1000).format("mm");
							// 	this.tomorroweh = moment(this.todayList.end_time * 1000).format("HH");
							// 	this.tomorrowem = moment(this.todayList.end_time * 1000).format("mm");
							// 	let activityId = [this.activityList2.tomorrow_activity.id];
							// 	activityId = activityId.length ? activityId.join(",") : "0";
							// 	this.checkSpikesTomorrow(activityId);
							// }
						}
					});
				}
			});
		},
		//秒杀
		checkSpikesToday(id) {
			this.$api.GetSpikesList({ list_rows: 10, activity_id: id, page: 1, keyword: null, min_price: null, max_price: null, min_stock: null, max_stock: null, sort: null, order: null }).then((res) => {
				if (res.code == 1) {
					this.spikesListToday = res.data.data;
				}
			});
		},
		//秒杀
		checkSpikesTomorrow(id) {
			this.$api.GetSpikesList({ list_rows: 10, activity_id: id, page: 1, keyword: null, min_price: null, max_price: null, min_stock: null, max_stock: null, sort: null, order: null }).then((res) => {
				if (res.code == 1) {
					this.spikesListTomorrow = res.data.data;
				}
			});
		},
		// 获取轮播和广告图
		getBanner() {
			let that = this;
			that.$api.GetBanner().then((res) => {
				that.banner = res.data.pc_index;
				that.advertise = res.data.pc_index_advert;
			});
		},
		// 跳页面
		toPage(url) {
			this.$router.push(url);
		},
		// 跳页面带参数
		toPagePrarm(url, param) {
			this.$router.push({ path: url, query: param });
		},
		// 跳页面带参数
		toPagePrarmTag(url, param) {
			if (this.isLogin == false) {
				this.$router.push({ path: url, query: param });
			} else {
				let routeUrl = this.$router.resolve({ path: url, query: param });
				window.open(routeUrl.href, "_blank");
			}
		},
		// 获取分类
		getCategoryList() {
			this.$api.GetCategoryList().then((res) => {
				if (res.code == 1) {
					this.categoryList = res.data;
				}
			});
		},
		// 获取热门产品列表
		getHotGoodsList() {
			this.$api.GetHotGoodsList({ list_rows: 8 }).then((res) => {
				if (res.code == 1) {
					this.hotCategoryList = res.data;
				}
			});
		},
		// 获取推荐品牌列表
		getBrandListList() {
			this.$api.GetBrandListList({ 'list_rows': 12 }).then((res) => {
				if (res.code == 1) {
					this.brandList = res.data.data;
				}
			});
		},
		// 获取消息
		getMessageList() {
			this.$api
				.GetMessageListAll({ page: 1, list_rows: 20 })
				.then((res) => {
					if (res.code == 1) {
						this.messageList = res.data.data;
						this.showmess = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getActivityList() {
			this.$api.GetActivityList({ list_rows: 3 }).then((res) => {
				this.activityList = res.data;
				this.activityList.map((item) => {
					// 万件拼团
					if (item.type == "groupon") {
						this.activityList0 = item;
					}
					// 新品体验
					if (item.type == "new_sample") {
						this.activityList1 = item;
					}
					// 临期产品
					if (item.type == "expiry_food") {
						this.activityList3 = item;
					}
				});
			});
		},
	},
};
</script>
<style lang="less" scoped>
@import url(../../assets/css/reset.css);
@import url(../../assets/css/style.css);

.ico24 {
	width: 24px;
	height: auto;
}

.bgbe {
	background: #beddff;
}

.pl8 {
	padding-left: 8px;
}

.col65 {
	color: #656565;
}

.pl24 {
	padding-left: 24px;
}
.h18{height: 18px;}
.col4c {
	color: #4c4c4c;
}

.coleb {
	color: #eb3f25;
}

.col96 {
	color: #969696;
}

.col3d {
	color: #3d7efe;
}

.colfe {
	color: #fe8181;
}

.ico27 {
	width: 30px;
	height: 30px;
	object-fit: contain;
}

.h28 {
	height: 38px;
}

.col27 {
	color: #272727;
}

.pl8 {
	padding-left: 8px;
}

.pr45 {
	padding-right: 45px;
}

.ico10 {
	width: 11px;
	height: auto;
}

.cola4 {
	color: #a4a4a4;
}

.mt32 {
	margin-top: 32px;
}

.col5d {
	color: #5d5d5d;
}

span {
	display: inline-block;
	white-space: pre-line;
}

.container {
	background-color: #f9f9f9;
}

.left_recomd {
	width: 264px;
	background: #fff;
	position: relative;
	z-index: 90;

	.top_nav {
		height: 55px;
		z-index: 100;
		width: 100%;
		border-radius: 10px 10px 0 0;
		background: #398af3;
		position: absolute;
		top: -55px;
		left: 0;
		font-size: 16px;
		font-weight: bold;
		color: #ffffff;
		cursor: pointer;
		padding-left: 20px;

		img {
			width: 20px;
			height: 20px;
			object-fit: cover;
			margin-right: 10px;
		}
	}

	.left_item {
		height: 100px;
		padding: 20px 20px 10px;
		cursor: pointer;
		position: relative;

		&:hover {
			background: #f2f7ff;
		}

		.pop {
			height: 100%;
			position: absolute;
			width: 876px;
			background: #f2f7ff;
			left: 264px;
			top: 0;
			overflow-x: hidden;
			// white-space: nowrap;
			display: none;
			cursor: default;
			padding: 10px 0;
		}

		&:hover .pop {
			display: flex;
		}

		.pop li {
			font-size: 16px;
			display: inline-block;
			vertical-align: top;
			margin-left: 40px;
			cursor: pointer;
		}

		.pop li a {
			line-height: 30px;
			color: #272727;
			display: block;
		}

		.pop li:hover a {
			color: #398af3;
		}
	}

	span {
		letter-spacing: 1.4px;
	}
}

.home_swiper {
	// width: 1040px;
	height: 425px;
	position: relative;
	z-index: 1;

	.swiper_item {
		width: 100%;
		height: 100%;
	}

	.top_banner {
		width: 100%;
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.swiper_arrow_left {
		width: 46px;
		height: auto;
		position: absolute;
		z-index: 2;
		left: 40px;
		top: 50%;
		transform: translateY(-50%);
	}

	.swiper_arrow_right {
		width: 46px;
		height: auto;
		position: absolute;
		z-index: 2;
		right: 40px;
		top: 50%;
		transform: translateY(-50%);
	}
}

.right_profile {
	width: 290px;
	background: #fff;
	padding: 10px;
	position: relative;

	.before {
		width: 290px;
		height: 55px;
		border-radius: 10px 10px 0 0;
		background: #88b9f8;
		position: absolute;
		top: -55px;
		left: 0;
		z-index: 1;
	}

	.user_header_box {
		width: 86px;
		height: 86px;
		border-radius: 50%;
		margin-left: auto;
		margin-right: auto;

		img {
			width: 100%;
			height: 100%;
			display: block;
			object-fit: cover;
			border-radius: 50%;
		}
	}

	.info {
		width: 100%;
		padding-bottom: 10px;
		position: relative;

		&::after {
			content: "";
			height: 1px;
			background: #e5e5e5;
			position: absolute;
			left: -10px;
			right: -10px;
			bottom: 0;
		}

		.vip {
			width: 48px;
			height: 14px;
			background: #e8eff0;
			box-shadow: 0px 0px 5px 0px rgba(239, 239, 239, 0.5);
			border-radius: 7px;
			padding-right: 2px;
			font-weight: 500;
			font-size: 14px;
			color: #607a87;
			margin-top: 10px;

			&.nor {
				background: transparent;
			}

			.vip_ico {
				width: 12px;
				height: 12px;
				border-radius: 50%;
				object-fit: cover;
			}
		}
	}

	&_item {
		margin-top: 15px;
		display: inline-block;
		vertical-align: top;
		width: 33%;
		color: #272727;
		font-size: 14px;
		font-weight: 400;
		text-align: center;

		img {
			width: 48px;
			height: auto;
			margin-bottom: 15px;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}
	}

	.notice_box {
		margin-top: 10px;
		width: 100%;
		height: 115px;
		border-radius: 8px;
		background: #f9f9f9;
		padding: 10px;

		.ico51 {
			width: 51px;
		}
	}
}

.ad_box {
	width: 100%;

	.ad_img {
		width: calc((100% - 10px - 10px) / 3);
		height: 106px;
		object-fit: cover;
		margin-top: 10px;
		margin-right: 10px;
		// display: inline-block;
		display: block;
		vertical-align: top;
	}

	.ad_img:nth-of-type(3n) {
		margin-right: 0;
	}
}

.btn_login {
	color: #ffffff;
	font-size: 16px;
	text-align: center;
	width: 130px;
	height: 40px;
	line-height: 40px;
	border-radius: 27px;
	background: #3d7efe;
}

.btn_register {
	width: 130px;
	height: 40px;
	border-radius: 27px;
	border: 1px solid #3d7efe;
	line-height: 38px;
	color: #3d7efe;
	font-size: 16px;
	text-align: center;
	margin-left: 28px;
}

.notice_swiper {
	width: 100%;
	height: 95px;
}

.con1 {
	width: 100%;
	height: 30px;
	display: flex;
	align-items: center;
	padding: 0 10px;
	color: #272727;
	font-size: 12px;
	border-radius: 10px;
	background: #f0f0f0;

	div {
		font-size: 14px;
	}
}

.million_pay_box {
	width: 1440px;
	height: auto;
	margin-left: auto;
	margin-right: auto;
	position: relative;

	.jj_title0 {
		width: 1433px;
		height: auto;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
	}

	.more {
		position: absolute;
		top: 25px;
		right: 71px;
		width: 75px;
		z-index: 3;
	}

	.million_pay_ulb {
		width: 1440px;
		height: auto;
		position: relative;
		z-index: 2;
		padding-top: 124px;
	}

	.million_pay_ul {
		width: 1440px;
		height: auto;
		background: #deecff;
		border-radius: 32px;
		position: relative;
		z-index: 2;
		padding: 20px;
	}

	.million_pay_link {
		width: 456px;
		min-height: 210px;
		border-radius: 17px;
		background: #ffffff;
		padding: 12px;
		display: inline-flex;
		vertical-align: top;
		margin-right: 16px;
		margin-top: 16px;

		&:nth-of-type(-n + 3) {
			margin-top: 0;
		}

		&:nth-of-type(3n) {
			margin-right: 0;
		}

		.cover {
			width: 206px;
			height: 186px;
			border-radius: 17px;
			border-radius: 11.27px;
			object-fit: cover;
			display: block;
		}
	}

	.progree_nav {
		height: 12px;
		position: relative;

		&_box {
			position: relative;
			width: 156px;
			height: 12px;
			border-radius: 6.36px;
			border: 0.8473849px solid #e3ecf7;
		}

		&_box_active {
			position: absolute;
			top: 50%;
			left: 2px;
			transform: translateY(-50%);
			height: 8px;
			border-radius: 177px;
			background: #feb833;
		}

		&_box_active::after {
			content: "";
			width: 20px;
			height: 20px;
			background-position: center;
			background-repeat: no-repeat;
			background-size: contain;
			position: absolute;
			right: -12.5px;
			top: 50%;
			transform: translateY(-50%);
			background-image: url("../../assets/static/icon/jj_icon_progress.png");
		}
	}

	.btn_million_pay {
		color: #ffffff;
		font-size: 16px;
		font-weight: 500;
		width: 202px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		border-radius: 16.23px;
		background: #3d7efe;
		margin-top: 10px;
		display: block;
	}
}

.today_pay_box {
	width: 1440px;
	margin-left: auto;
	margin-right: auto;
	position: relative;

	.jj_title1 {
		width: 1082px;
		height: auto;
		position: absolute;
		z-index: 3;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.today_pay_ulb {
		width: 1440px;
		margin-top: 28px;
		position: relative;
		z-index: 1;
		background: #ffdbdb;
		border-radius: 32px;
		padding: 36px 36px 36px;
	}

	.today_pay_ul {
		width: 100%;
		background: rgba(255, 255, 255, 0.4);
		border-radius: 32px;
		padding: 10px 42px 36px;
	}

	.countdown_box {
		margin-top: 25px;
		width: 100%;
		height: 179px;
		border-radius: 30px;
		background: #ffffff;
		padding: 24px 44px 0;
	}

	.countdown_box.c1 {
		margin-top: 24px;
	}

	.btn_count {
		padding: 0 31px;
		height: 55px;
		text-align: center;
		font-size: 22px;
		font-weight: 500;
		line-height: 53px;
		border-radius: 27px;
		border: 1px solid #fd7e7e;

		&_uc {
			padding: 0 31px;
			height: 55px;
			text-align: center;
			font-size: 22px;
			font-weight: 500;
			line-height: 53px;
			border-radius: 27px;
			border: 1px solid #d8d8d8;

			span {
				color: #969696;
				background: transparent;
			}
		}

		span {
			background: linear-gradient(180deg, #ffafaf 0%, #fe7c7c 100%);
			/*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
			background-clip: text;
			-webkit-background-clip: text;
			/*将设置的背景颜色限制在文字中*/
			-webkit-text-fill-color: transparent;
			/*给文字设置成透明*/
		}
	}
}

.count_item {
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	width: 101px;
	height: 73px;
	color: #ffffff;
	font-size: 65px;
	font-stretch: condensed;
	font-weight: 600;
	text-align: center;
	line-height: 73px;
	letter-spacing: 0.08rem;
	padding-left: 0.015rem;
}

.count_span {
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	width: 26.35px;
	height: 101.35px;
	background-image: url("../../assets/static/images/jj_countdown_red_f.png");

	&.gray {
		background-image: url("../../assets/static/images/jj_countdown_gray_f.png");
	}
}

.count_span_split {
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	width: 30px;
	height: 88px;
	background-image: url("../../assets/static/images/jj_countdown_red_s.png");
	margin-left: 20px;
	margin-right: 20px;

	&.gray {
		background-image: url("../../assets/static/images/jj_countdown_gray_s.png");
	}
}

.ml8 {
	margin-left: 8px;
}

.cole6 {
	color: #e61313;
}

.mt6 {
	margin-top: 6px;
}

.endtime_pay_box {
	width: 1440px;
	margin-left: auto;
	margin-right: auto;
	position: relative;
	padding-top: 24px;

	.jj_title2 {
		width: 1433px;
		height: auto;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1;
	}

	.jj_title3 {
		width: 750px;
		height: auto;
		position: absolute;
		top: -4px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 3;
	}

	.endtime_pay_ulb {
		background: #dad7ff;
		border-radius: 32px;
		width: 1440px;
		padding: 27px 36px 36px;
		position: relative;
		z-index: 2;
	}

	.endtime_pay_ul {
		width: 100%;
		padding: 18px 42px 36px;
		background: rgba(255, 255, 255, 0.4);
		border-radius: 32px;
		margin-top: 57px;
	}
}

.new_pay_box {
	width: 1440px;
	min-height: 508px;
	margin-left: auto;
	margin-right: auto;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-image: url("../../assets/static/images/jj_new_pay.png");
	position: relative;
	padding: 50px 20px 15px;

	.new_pay_poster {
		width: 360px;
		height: 438px;
		object-fit: cover;
		display: block;
		height: auto;
		border-radius: 10px;
	}

	.countdown_goods {
		margin-top: 0;
	}

	.countdown_goods:nth-of-type(4n) {
		margin-right: 0;
	}
}

.hot_pay_box {
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	border-radius: 18px;
	background: #ffffff;
	position: relative;
	padding: 10px;
	z-index: 2;

	.more {
		font-size: 16px;
		color: #6b6b6b;

		&::after {
			content: "";
			width: 12px;
			height: 12px;
			background-position: 50% 50%;
			background-size: cover;
			background-repeat: no-repeat;
			display: inline-block;
			background-image: url("../../assets/static/icon/jj_new_arrow.png");
		}
	}

	// &::before {
	// 	content: '';
	// 	width: 1440px;
	// 	height: 79px;
	// 	background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(211, 229, 255, 0.67) 100%);
	// 	position: absolute;
	// 	transform: scaleY(-1);
	// 	border-radius: 0 0 40px 40px;
	// 	top: 0;
	// 	left: 0;
	// 	z-index: 1;
	// }

	// &::after {
	// 	content: '';
	// 	width: 1440px;
	// 	height: 79px;
	// 	background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(211, 229, 255, 0.67) 100%);
	// 	position: absolute;
	// 	bottom: 0;
	// 	left: 0;
	// 	z-index: 1;
	// 	border-radius: 0 0 40px 40px;
	// }

	.hot_goods_ul {
		.hot_goods_link {
			margin-top: 10px;
			display: inline-block;
			width: 347px;
			border-radius: 24px;
			background: #ffffff;
			padding: 22px 10px;
			margin-right: 10px;
			vertical-align: top;
			border: 1px solid #ececec;

			&:nth-of-type(4n) {
				margin-right: 0;
			}

			.cover {
				width: 300px;
				height: 300px;
				border-radius: 24px;
				display: block;
				margin-left: auto;
				margin-right: auto;
				object-fit: cover;
			}

			.sq {
				width: calc(100% + 20px);
				margin-bottom: 10px;
				height: 2px;
				background: #ececec;
				margin-top: 10px;
				margin-left: -10px;
				margin-right: -10px;
			}

			.title {
				height: 56px;
				color: #272727;
				line-height: 28px;
				font-weight: 500;
			}
		}
	}
}

.col9d {
	color: #9d95ff;
}

.mt84 {
	margin-top: 84px;

	.countdown_goods {
		margin-top: 16px;
		height: auto;
		border-radius: 17.86px;
		background: #ffffff;
		padding: 12px 0 15px;
	}
}

.ico28 {
	width: 24px;
	height: auto;
	display: block;
}

.ico40 {
	width: 40px;
	height: auto;
}

.pl16 {
	padding-left: 16px;
}

.ico56 {
	width: 52px;
	height: auto;
}

.col6b {
	color: #6b6b6b;
}

.w1440 {
	width: 1440px;
	margin-left: auto;
	margin-right: auto;
}

.pb80 {
	padding-bottom: 80px;
}

.comp_link {
	width: 231px;
	margin-top: 10px;
	display: inline-block;
	background: #fff;
	vertical-align: top;
	border-radius: 12px;
	margin-right: 10px;

	&:nth-of-type(6n) {
		margin-right: 0;
	}

	.cover {
		width: 231px;
		height: 225px;
		border-radius: 12px 12px 0 0;
		object-fit: contain;
		display: block;
	}

	.bottom {
		width: 225px;
		height: 58px;
		line-height: 58px;
		border-radius: 0 0 12px 12px;
		padding-left: 15px;
		padding-right: 15px;
		text-align: center;
	}
}

.pl35 {
	padding-left: 35px;
}

.fw400 {
	font-weight: 400;
}

.disi {
	display: inline-block;
	text-align: right;
	margin-left: auto;
}

.mlra {
	margin-left: auto;
	margin-right: auto;
	text-align: center;

	div {
		display: inline-block;
	}
}

.pbrem2 {
	padding-bottom: 0.2rem;
}

.new_goods_nav {
	width: calc(50% - 5px);
	display: inline-block;
	vertical-align: top;
	background: #caddff;
	padding: 10px;
	border-radius: 18px;

	.nodata {
		height: 355px;
		margin-top: 10px;
	}

	&.new {
		background: #fedd9d;
	}

	&.endtime {
		background: #dad7ff;
		margin-left: 10px;
	}

	.goods_pay {
		padding: 10px;
		border-radius: 18px;
		background: rgba(255, 255, 255, 0.4);
	}

	.more {
		font-size: 16px;
		color: #6b6b6b;

		&::after {
			content: "";
			width: 12px;
			height: 12px;
			background-position: 50% 50%;
			background-size: cover;
			background-repeat: no-repeat;
			display: inline-block;
			background-image: url("../../assets/static/icon/jj_new_arrow.png");
		}
	}

	.million_pay_ul {
		width: 100%;

		.million_pay_link {
			display: inline-block;
			vertical-align: top;
			margin-top: 10px;
			margin-right: 10px;
			width: 218px;
			border-radius: 18px;
			background: #ffffff;
			padding: 10px 10px;
			min-height: 355px;

			.cover {
				width: 100%;
				height: 198px;
				object-fit: cover;
				display: block;
				border-radius: 18px;
			}
		}

		.million_pay_link:nth-of-type(3n) {
			margin-right: 0;
		}
	}

	.progree_nav {
		height: 10px;
		position: relative;

		&_box {
			position: relative;
			width: 60px;
			margin-left: 10px;
			height: 10px;
			border-radius: 6.36px;
			border: 0.8473849px solid #e3ecf7;
		}

		&_box_active {
			position: absolute;
			top: 50%;
			left: 2px;
			transform: translateY(-50%);
			height: 6px;
			border-radius: 117px;
			background: #feb833;
		}

		&_box_active::after {
			content: "";
			width: 20px;
			height: 20px;
			background-position: center;
			background-repeat: no-repeat;
			background-size: contain;
			position: absolute;
			right: -12.5px;
			top: 50%;
			transform: translateY(-50%);
			background-image: url("../../assets/static/icon/jj_icon_progress.png");
		}
	}

	.countdown_ul {
		.countdown_goods {
			display: inline-block;
			vertical-align: top;
			margin-top: 10px;
			margin-right: 10px;
			width: 218px;
			border-radius: 18px;
			background: #ffffff;
			padding: 10px;
			min-height: 355px;

			.cover {
				width: 100%;
				height: 198px;
				border-radius: 18px;
				display: block;
				margin-left: auto;
				margin-right: auto;
				object-fit: cover;
			}

			.number_span {
				width: 100%;
				line-height: 18px;
				border-radius: 4px;
				background: #d7e5ff;
				margin-left: auto;
				margin-right: auto;
				text-align: center;
				color: #70a0fe;
				margin-top: 5px;
				padding: 0 5px;

				span {
					color: #70a0fe;
				}
			}

			&:nth-of-type(3n) {
				margin-right: 0;
			}
		}
	}
}

.ico30 {
	width: 30px;
	height: auto;
}

.time_pay_nav {
	width: calc(50% - 5px);
	display: inline-block;
	vertical-align: top;
	background: #ffdbdb;
	padding: 10px;
	border-radius: 18px;
	margin-left: 10px;

	.time_pay {
		padding: 10px;
		border-radius: 18px;
		background: rgba(255, 255, 255, 0.4);
	}

	.nodata {
		height: 355px;
		margin-top: 10px;
	}

	.more {
		font-size: 16px;
		color: #6b6b6b;

		&::after {
			content: "";
			width: 12px;
			height: 12px;
			background-position: 50% 50%;
			background-size: cover;
			background-repeat: no-repeat;
			display: inline-block;
			background-image: url("../../assets/static/icon/jj_new_arrow.png");
		}
	}

	.countdown_ul {
		.countdown_goods {
			display: inline-block;
			vertical-align: top;
			margin-top: 10px;
			margin-right: 10px;
			width: 218px;
			border-radius: 18px;
			background: #ffffff;
			padding: 10px;
			min-height: 355px;

			.cover {
				width: 100%;
				height: 198px;
				border-radius: 18px;
				display: block;
				margin-left: auto;
				margin-right: auto;
				object-fit: cover;
			}

			.number_span {
				width: 100%;
				line-height: 18px;
				border-radius: 4px;
				background: #d7e5ff;
				margin-left: auto;
				margin-right: auto;
				text-align: center;
				color: #70a0fe;
				margin-top: 5px;
				padding: 0 5px;

				span {
					color: #70a0fe;
				}
			}

			&:nth-of-type(3n) {
				margin-right: 0;
			}
		}
	}
}

.recomd_title {
	width: 242px;
	height: auto;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.comp_title {
	.more {
		font-size: 16px;
		color: #6b6b6b;

		&::after {
			content: "";
			width: 12px;
			height: 12px;
			background-position: 50% 50%;
			background-size: cover;
			background-repeat: no-repeat;
			display: inline-block;
			background-image: url("../../assets/static/icon/jj_new_arrow.png");
		}
	}
}

.pl12 {
	padding-left: 15px;
}

@media screen and (max-width: 1440px) {
	.left_recomd {
		width: 264px;
		background: #fff;
		position: relative;
		z-index: 90;

		.mb30 {
			margin-bottom: 20px;
		}

		.left_item {
			height: 90px;

			.pop li a {
				line-height: 25px;
			}

			.pop {
				width: 716px;
			}
		}
	}

	.right_profile {
		width: 290px;
		background: #fff;
		padding: 10px;
		position: relative;

		.before {
			width: 290px;
			height: 55px;
			border-radius: 10px 10px 0 0;
			background: #88b9f8;
			position: absolute;
			top: -55px;
			left: 0;
			z-index: 1;
		}

		.user_header_box {
			width: 76px;
			height: 76px;
			border-radius: 50%;
			margin-left: auto;
			margin-right: auto;

			img {
				width: 100%;
				height: 100%;
				display: block;
				border-radius: 50%;
			}
		}

		.info {
			width: 100%;
			padding-bottom: 10px;
			position: relative;
		}

		&_item {
			margin-top: 10px;

			img {
				width: 40px;
				margin-bottom: 10px;
			}
		}

		.notice_box {
			height: 80px;

			.ico51 {
				width: 51px;
			}
		}
	}

	.notice_swiper {
		height: 75px;
	}

	.home_swiper {
		// width: 1040px;
		height: 348px;
		position: relative;
		z-index: 1;
	}

	.hot_pay_box {
		.hot_goods_ul {
			.hot_goods_link {
				width: 307px;

				.cover {
					width: 280px;
					height: 280px;
				}
			}
		}
	}

	.new_goods_nav {
		.nodata {
			height: 329px;
			margin-top: 10px;
		}

		.million_pay_ul {
			width: 100%;

			.million_pay_link {
				width: 191px;
				min-height: 329px;

				.cover {
					height: 171px;
				}
			}
		}

		.progree_nav {
			height: 10px;
			position: relative;

			&_box {
				position: relative;
				width: 50px;
				margin-left: 8px;
				height: 10px;
				border-radius: 6.36px;
				border: 0.8473849px solid #e3ecf7;
			}
		}

		.countdown_ul {
			.countdown_goods {
				width: 191px;
				min-height: 329px;

				.cover {
					height: 171px;
				}
			}
		}
	}

	.time_pay_nav {
		.nodata {
			height: 329px;
		}

		.countdown_ul {
			.countdown_goods {
				width: 191px;
				min-height: 329px;

				.cover {
					height: 171px;
				}
			}
		}
	}

	.comp_link {
		width: 205px;
		margin-top: 10px;
		display: inline-block;
		background: #fff;
		vertical-align: top;
		border-radius: 12px;
		margin-right: 10px;

		&:nth-of-type(6n) {
			margin-right: 0;
		}

		.cover {
			width: 205px;
			height: 205px;
			border-radius: 12px 12px 0 0;
			object-fit: contain;
			display: block;
		}

		.bottom {
			width: 205px;
			height: 58px;
			line-height: 58px;
			border-radius: 0 0 12px 12px;
			padding-left: 15px;
			padding-right: 15px;
			text-align: center;
		}
	}

	.pl12 {
		padding-left: 12px;
	}
}
</style>

<style>
.home_swiper .swiper-pagination {
	margin-bottom: 0;
	bottom: 17px;
}

.home_swiper .swiper-pagination .swiper-pagination-bullet {
	width: 12px;
	height: 12px;
	background: rgba(255, 255, 255, 0.4);
	border-radius: 50%;
	cursor: pointer;
	margin-left: 14px;
	margin-right: 14px;
	border-radius: 50%;
	opacity: 1;
	vertical-align: middle;
}

.home_swiper .swiper-pagination .swiper-pagination-bullet-active {
	background: rgba(255, 255, 255, 0.4);
	width: 18px;
	height: 18px;
	border-radius: 50%;
	position: relative;
}

.home_swiper .swiper-pagination .swiper-pagination-bullet-active::before {
	content: "";
	width: 12px;
	height: 12px;
	position: absolute;
	top: 50%;
	left: 50%;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	background: #fff;
}

.con1 {
	width: 100%;
	height: 20px;
	line-height: 20px;
	padding: 0 10px;
	color: #272727;
	border-radius: 8px;
	font-size: 14px;
	border-radius: 10.12px;
	background: #f0f0f0;
}

.con1 div {
	line-height: 20px;
	font-size: 14px;
}

.z2 {
	z-index: 2;
}

.pr {
	position: relative;
}

.pl2 {
	padding-left: 2px;
}
</style>
